import { useState, useRef, useEffect } from 'react';
import styles from './UploadBtn.module.css'
import { useRecoilState} from 'recoil';
import { namespaceState, newTaskConfig } from '../../recoil/atoms';

import useApi from '../../services/useApi';
import getByteSize from '../../utils/getByteSize';
import Checkbox from '../../compoenets/Checkbox';

export default function UploadBtn({refreshModelList}){
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const inputFileRef=useRef(null);
  const nameRef=useRef(null);
  const [fileName,setFileName]=useState(null);
  const [namefocus,setNameFocus]=useState(false);
  const [nsState,setNsState] = useRecoilState(namespaceState);
  const [modelType,setModelType]=useState('classification');
  const [isDropReminder,setIsDropReminder]=useState(false);
  const nocRef=useRef(null);
  const [taskConfig,setTaskConfig] = useRecoilState(newTaskConfig);

  const handleUpload = async () => {
    if (!selectedFile) return;
    setUploading(true);

    const nowDate=new Date();
    const fileData = {
        modelName: fileName,
        userId: JSON.parse(localStorage.getItem('account')).id,
        modelDescription: nowDate.getFullYear()+ " / " + ("0" + (nowDate.getMonth() + 1)).slice(-2) + " / "+ ("0" + nowDate.getDate()).slice(-2), //설명 대충 아무거나 적으심
        namespaceId:nsState.id,
        type:modelType,
        dropReminder:isDropReminder,
        numOfClasses:modelType!=='classification'?0:nocRef.current.value,
        dataset:taskConfig.requiredData,
        size: selectedFile.size/1024,
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append("model", new Blob([JSON.stringify(fileData)], {type: "application/json"}))
    const config = {
        headers: {
            'content-type': 'multipart/mixed',
        },
    };

    // modelRegistry
    useApi.post('ngp/modelreg/mm/model/v1',formData,config).then((res)=>{
      setSelectedFile(null);
      setUploading(false);
      setUploadProgress(0);
      refreshModelList();
      inputFileRef.current.value = "";
    })
    .catch(async (error) => {
        if (error.response.data.code === "SE004" && error.response.status === 401) {
          alert(error.response.data.message)
        } else if (error.response.data.code === "SE006" && error.response.status === 409) {
          alert(error.response.data.message)
        } else {
          alert("upload model fail") 
        }
    });
  };

  const handleNameChange=(e)=>{
    setFileName(e.target.value);
  }

  const handleNameKeyDown=(e)=>{
    if(e.key==='Enter' && e.target.value===''){
        setFileName(selectedFile.name.replace(/\.[^.]*$/,''));
        nameRef.current.blur();
    } else if(e.key==='Enter'){
        nameRef.current.blur();
    } else if(e.key==='Escape'){
        nameRef.current.blur();
    }
  }

  const handleNameBlur=(e)=>{
    if(e.target.value==="") setFileName(selectedFile.name.replace(/\.[^.]*$/,''));
    setNameFocus(false);
  }

  const handleCancel=()=>{
    setSelectedFile(null);
    setUploading(false);
    inputFileRef.current.value = "";
  }

  useEffect(()=>{
    setFileName(selectedFile?selectedFile.name.replace(/\.[^.]*$/,''):"");
  },[selectedFile])

  const uploadProgressStyle = {
    background: 
    `radial-gradient(closest-side, #e8e7ed 79%, transparent 80% 100%), \
     conic-gradient(black ${uploadProgress}%, rgba(255, 255, 255,0) 0%)`
  }
  
  return(
    <div 
      className={`${styles["file-upload-container"]} 
        ${selectedFile&&styles['file-upload-selected']}`}
      onClick={(e)=>{!selectedFile && inputFileRef.current?.click()}}
    >
      <div className={styles["text-wrap"]}>
      {selectedFile?
        <div className={styles['file-item']}>
          <span>Name</span>
          <div className={styles["file-name-wrap"]}>
            <div>
              <input 
              className={`${styles["file-name"]}`}
              ref={nameRef}
              placeholder="File Name"
              value={fileName}
              onChange={handleNameChange}
              onKeyDown={handleNameKeyDown}
              onFocus={()=>setNameFocus(true)}
              onBlur={handleNameBlur}
              >
              </input>
              <span></span>
            </div>
            {!namefocus&&<div className={`${styles["file-name-icon"]}`} onClick={()=>{nameRef.current.focus()}}></div>}
          </div>
        </div>:
        <span className={`${styles["title"]}`}>Model Upload</span>
      }
      {selectedFile && 
      <>
        <div className={`${styles['file-item']} ${styles["type"]}`}>
          <span>Type</span>
          <div className={styles["type-item"]}>
            <div className={`${styles["type-item-btn"]} 
            ${modelType=='classification'&&styles['type-item-btn-on']}`} 
            onClick={()=>setModelType('classification')}>
              Classification
            </div>
            <input 
            ref={nocRef}
            className={`${styles["type-item-input"]} 
            ${modelType!='classification'&&styles['type-item-input-off']}`} 
            placeholder='numOfClasses'
            disabled={modelType=="classification"?false:true}>
            </input>
          </div>
          <div className={`${styles["type-item-btn"]} ${modelType=='regression'&&styles['type-item-btn-on']}`} onClick={()=>setModelType('regression')}>
            Regression
          </div>
          <div className={`${styles["type-item-btn"]} ${modelType=='generation'&&styles['type-item-btn-on']}`} onClick={()=>setModelType('generation')}>
            Generation
          </div>
        </div>
        <div className={styles['file-item']}>
          <span>Hyperparameter</span>
          <div className={styles['checkbox-dropreminder']}>
            <Checkbox
            textStyle={styles['checkbox-wrap']}
            text="dropReminder"
            onChange={()=>setIsDropReminder(!isDropReminder)}
            />
            <div className={styles['checkbox-dropreminder-info']}></div>
          </div>
        </div>
        <div className={styles['file-item']}>
          <span>Size</span>
          <span className={styles["size"]}>{getByteSize(selectedFile.size/1024)}</span>
        </div>
      </>
      }
      {selectedFile &&
      <div className={styles["btn-wrap"]}>
        {!uploading?<>
        <div className={`${styles["btn-upload"]}`} onClick={uploading==false ? handleUpload : undefined}>
        <span>Upload</span>

        </div>
        <div className={styles["btn-cancel"]}
          onClick={handleCancel}
        >Cancel</div>
        </>
        :<>
        <div 
        className={`${styles["upload-percent"]}`}
        style={uploadProgressStyle}
        >{uploadProgress}%
        </div>
        {uploadProgress==100 &&
        <svg className={styles["upload-checkmark"]} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle className={styles["upload-checkmark-circle"]} cx="26" cy="26" r="25" fill="none"/>
          <path className={styles["upload-checkmark-check"]} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg> 
        }
        </>}
      </div>
      }
      </div>
      <input type="file" 
        ref={inputFileRef} 
        className={styles["input"]} 
        onChange={(e)=>setSelectedFile(e.target.files[0])} />
    </div>
  )
}